module.exports = __webpack_public_path__ + "img/Instagram_Story_Icon_5@svg.4e1b5cc2.svg";